import WatermarkWorker from 'worker-loader!@/worker/watermark.worker';
import runWorker from './upload/runWorker';
import { MessageData } from '@/worker/watermark.worker';

export default {
    generate(photo: Uint8Array, watermark: Uint8Array|null,
        { opacity, size, spacing, antiAiLevel }: { opacity: number, size: number, spacing: number, antiAiLevel?: number },
        signal?: AbortSignal,
    ) {
        const message: MessageData = { photo, watermarkImage: watermark || undefined, opacity, size, spacing, antiAiLevel };
        return runWorker<Uint8Array>(new WatermarkWorker(), message, signal ? [photo.buffer] : [], signal);
    },
};
